import { getPersonSchema } from "@/services/api";

export const activitiesTabSchema = getPersonSchema().pick([
  "professionalActivities",
  "careers",
  "educations",
  "competences",
  "hobbies",
]);
